import React from "react";

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g>
      <path
        d="M0 2.729L0 2C0 1.448.448 1 1 1L3 1 3 2 1 2 1 14 5 14 5 15 1 15C.448 15 0 14.552 0 14L0 9 0 2.729zM12 5L12 2C12 1.448 11.552 1 11 1L9 1 9 2 11 2 11 5 12 5zM11 6L13 6 13 15 12 15 6 15 6 10 6 9.458 6 6 11 6 11 5 6 5C5.448 5 5 5.448 5 6L5 15C5 15.552 5.448 16 6 16L13 16C13.552 16 14 15.552 14 15L14 6C14 5.448 13.552 5 13 5L11 5 11 6z"/>
      <polygon points="7 10 12 10 12 9 7 9"/>
      <polygon points="7 8 12 8 12 7 7 7"/>
      <polygon points="7 12 12 12 12 11 7 11"/>
      <polygon points="7 14 12 14 12 13 7 13"/>
      <path d="M9,2 L9,1 C9,0.448 8.552,0 8,0 L4,0 C3.448,0 3,0.448 3,1 L3,2 L4,2 L4,1 L8,1 L8,2 L9,2 Z"/>
      <polygon points="3 3 9 3 9 2 3 2"/>
    </g>
  </svg>
);
